<template>

  <b-col cols="12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row
            align-h="center"
          >
            <div style="display: flex;">
              <h4>
                Índice geral de propostas</h4>
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  title="Nesse índice é consolidado todos os checklists e propostas por status, cadastrados até a data atual."
                  style="font-size: 0.85rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </div>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <span style="margin-bottom: 0.8rem">
                Total Geral: {{ totalPropostas.numeroPropostas }} [100%] {{ totalPropostas.valorTotalPropostas | converteValor }}</span>
            </b-col>
          </b-row>
          <totalizador-comercial />
        </b-card>
        <b-row>
          <b-col cols="4">
            <b-card
              no-body
              class="class-card"
            >
              <detalhamento-checklist />
            </b-card>
          </b-col>

          <b-col cols="4">
            <b-card
              no-body
              class="class-card"
            >
              <detalhamento-proposta />
            </b-card>
          </b-col>

          <b-col cols="4">
            <b-card
              no-body
              class="class-card"
            >
              <detalhamento-contrato />
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-card style="min-height: 675px;">
              <detalhamento-finalizadas />
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-col>

</template>
<style lang="scss">

  .class-card{
  padding: 10px;
  }

</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import api from './shared/services/api'

export default {
  name: 'DashboardComercial',
  components: {
    FontAwesomeIcon,
    TotalizadorComercial: () => import('./shared/components/totalizador-comercial/TotalizadorComercial.vue'),
    DetalhamentoChecklist: () => import('./shared/components/detalhamento-checklist/DetalhamentoChecklist.vue'),
    DetalhamentoContrato: () => import('./shared/components/detalhamento-contrato/DetalhamentoContrato.vue'),
    DetalhamentoProposta: () => import('./shared/components/detalhamento-proposta/DetalhamentoProposta.vue'),
    DetalhamentoFinalizadas: () => import('./shared/components/detalhamento-finalizadas/DetalhamentoFinalizadas.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      totalPropostas: [],
    }
  },
  created() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
    this.aplicar()
  },
  destroyed() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', false)
  },
  methods: {
    aplicar() {
      api.getDadosIniciais()
        .then(payload => {
          this.totalPropostas = payload.data
        })
    },
  },
}
</script>
